module.exports = __webpack_public_path__ + "static/img/news@2x.6f0ccac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsCenter/news@2x.png
// module id = a+mh
// module chunks = 44